import add from 'src/assets/svg/add.svg';
import addCircle from 'src/assets/svg/addCircle.svg';
import address from 'src/assets/svg/address.svg';
import altArrowLeft from 'src/assets/svg/altArrowLeft.svg';
import arrowLeft from 'src/assets/svg/arrowLeft.svg';
import arrowLeftBlack from 'src/assets/svg/arrowLeftBlack.svg';
import automate_checkout from 'src/assets/svg/automate_checkout.svg';
import backIcon from 'src/assets/svg/backIcon.svg';
import backIconWhite from 'src/assets/svg/backIconWhite.svg';
import battery from 'src/assets/svg/battery.svg';
import batteryCharge from 'src/assets/svg/batteryCharge.svg';
import bbody from 'src/assets/svg/bbody.svg';
import bbrake from 'src/assets/svg/bbrake.svg';
import bicycle from 'src/assets/svg/bicycle.svg';
import bicycleblack from 'src/assets/svg/bicycleblack.svg';
import bicyclepicture from 'src/assets/svg/bicyclepicture.svg';
import bike from 'src/assets/svg/bike.svg';
import bikeMotor from 'src/assets/svg/bikeMotor.svg';
import bikeMotorblack from 'src/assets/svg/bikeMotorblack.svg';
import bikeblack from 'src/assets/svg/bikeblack.svg';
import bikesymbol from 'src/assets/svg/bikesymbol.svg';
import blight from 'src/assets/svg/blight.svg';
import blueSetting from 'src/assets/svg/blueSetting.svg';
import body from 'src/assets/svg/body.svg';
import bolt from 'src/assets/svg/bolt.svg';
import bpedal from 'src/assets/svg/bpedal.svg';
import bsaddle from 'src/assets/svg/bsaddle.svg';
import btire from 'src/assets/svg/btire.svg';
import buy_product from 'src/assets/svg/buy_product.svg';
import cameraAdd from 'src/assets/svg/cameraAdd.svg';
import cameraAddIcon from 'src/assets/svg/cameraAddIcon.svg';
import cameraIcon from 'src/assets/svg/cameraIcon.svg';
import cancelIcon from 'src/assets/svg/cancelIcon.svg';
import check from 'src/assets/svg/check.svg';
import checkCircle from 'src/assets/svg/checkCircle.svg';
import checkbox from 'src/assets/svg/checkbox.svg';
import checkout from 'src/assets/svg/checkout.svg';
import circleBicycle from 'src/assets/svg/circleBicycle.svg';
import circleMotor from 'src/assets/svg/circleMotor.svg';
import circleParking from 'src/assets/svg/circleParking.svg';
import circleStep1 from 'src/assets/svg/circleStep1.svg';
import circleStep2 from 'src/assets/svg/circleStep2.svg';
import circleStep3 from 'src/assets/svg/circleStep3.svg';
import closeCircle from 'src/assets/svg/closeCircle.svg';
import closeCircleFill from 'src/assets/svg/closeCircleFill.svg';
import closeIcon from 'src/assets/svg/closeIcon.svg';
import closeSimple from 'src/assets/svg/closeSimple.svg';
import confrimbycicle from 'src/assets/svg/confrimbycicle.svg';
import confrimcharge from 'src/assets/svg/confrimcharge.svg';
import confrimmotor from 'src/assets/svg/confrimmotor.svg';
import counter1 from 'src/assets/svg/counter1.svg';
import counter2 from 'src/assets/svg/counter2.svg';
import dangerCircle from 'src/assets/svg/dangerCircle.svg';
import display from 'src/assets/svg/display.svg';
import dots from 'src/assets/svg/dots.svg';
import downIcon from 'src/assets/svg/downIcon.svg';
import downarrow from 'src/assets/svg/downarrow.svg';
import edit from 'src/assets/svg/edit.svg';
import empty from 'src/assets/svg/empty.svg';
import endTripIcon from 'src/assets/svg/endTripIcon.svg';
import endTripIconbycicle from 'src/assets/svg/endTripIconbycicle.svg';
import financeIcon from 'src/assets/svg/financeIcon.svg';
import flash from 'src/assets/svg/flash.svg';
import freeRides from 'src/assets/svg/freeRides.svg';
import frontCamera from 'src/assets/svg/frontCamera.svg';
import galleryCheck from 'src/assets/svg/galleryCheck.svg';
import goBack from 'src/assets/svg/goBack.svg';
import gray from 'src/assets/svg/gray.svg';
import hats from 'src/assets/svg/hats.svg';
import historytripsIcon from 'src/assets/svg/historytripsIcon.svg';
import icCodeIcon from 'src/assets/svg/icCodeIcon.svg';
import icFinanceIcon from 'src/assets/svg/icFinanceIcon.svg';
import icWalletIcon from 'src/assets/svg/icWalletIcon.svg';
import increase_by_gateway from 'src/assets/svg/increase_by_gateway.svg';
import increase_deposit_by_gateway from 'src/assets/svg/increase_deposit_by_gateway.svg';
import increase_wallet_by_gateway from 'src/assets/svg/increase_wallet_by_gateway.svg';
import info3 from 'src/assets/svg/info3.svg';
import info4 from 'src/assets/svg/info4.svg';
import instagram from 'src/assets/svg/instagram.svg';
import invt from 'src/assets/svg/invt.svg';
import khoshamadid1 from 'src/assets/svg/khoshamadid1.svg';
import khoshamadid2 from 'src/assets/svg/khoshamadid2.svg';
import khoshamadid3 from 'src/assets/svg/khoshamadid3.svg';
import leftIcon from 'src/assets/svg/leftIcon.svg';
import light from 'src/assets/svg/light.svg';
import linkedin from 'src/assets/svg/linkedin.svg';
import locationIcon from 'src/assets/svg/locationIcon.svg';
import lockwarning from 'src/assets/svg/lockwarning.svg';
import login from 'src/assets/svg/login.svg';
import logo from 'src/assets/svg/logo.svg';
import logo_icon from 'src/assets/svg/logo_icon.svg';
import mailIcon from 'src/assets/svg/mailIcon.svg';
import man from 'src/assets/svg/man.svg';
import mapOptionIcon from 'src/assets/svg/mapOptionIcon.svg';
import mirror from 'src/assets/svg/mirror.svg';
import motor_bicycle_scooter from 'src/assets/svg/motor_bicycle_scooter.svg';
import motor_bicycle_scooter_black from 'src/assets/svg/motor_bicycle_scooter_black.svg';
import motorbackground from 'src/assets/svg/motorbackground.svg';
import motorpicture from 'src/assets/svg/motorpicture.svg';
import motorsymbol from 'src/assets/svg/motorsymbol.svg';
import nearst from 'src/assets/svg/nearst.svg';
import newversion from 'src/assets/svg/newversion.svg';
import noconnection from 'src/assets/svg/noconnection.svg';
import noidcart from 'src/assets/svg/noidcart.svg';
import options from 'src/assets/svg/options.svg';
import parkingPin from 'src/assets/svg/parkingPin.svg';
import pauseTripIcon from 'src/assets/svg/pauseTripIcon.svg';
import pelakImage from 'src/assets/svg/pelakImage.svg';
import pen from 'src/assets/svg/pen.svg';
import penSquare from 'src/assets/svg/penSquare.svg';
import penalty from 'src/assets/svg/penalty.svg';
import penalty_on_deposit from 'src/assets/svg/penalty_on_deposit.svg';
import penaltycart from 'src/assets/svg/penaltycart.svg';
import photorule from 'src/assets/svg/photorule.svg';
import pictureIcon from 'src/assets/svg/pictureIcon.svg';
import plus from 'src/assets/svg/plus.svg';
import plusIcon from 'src/assets/svg/plusIcon.svg';
import prize from 'src/assets/svg/prize.svg';
import qrCodeSample from 'src/assets/svg/qrCodeSample.svg';
import radiobutton from 'src/assets/svg/radiobutton.svg';
import redAllDevices from 'src/assets/svg/redAllDevices.svg';
import redBicycle from 'src/assets/svg/redBicycle.svg';
import redIcon from 'src/assets/svg/redIcon.svg';
import redIcondamage from 'src/assets/svg/redIcondamage.svg';
import redMotor from 'src/assets/svg/redMotor.svg';
import redParking from 'src/assets/svg/redParking.svg';
import redleftIcon from 'src/assets/svg/redleftIcon.svg';
import redwarninng from 'src/assets/svg/redwarninng.svg';
import refreshBlack from 'src/assets/svg/refreshBlack.svg';
import reservestreetIcon from 'src/assets/svg/reservestreetIcon.svg';
import resumeIcon from 'src/assets/svg/resumeIcon.svg';
import return_deposit from 'src/assets/svg/return_deposit.svg';
import rightIcon from 'src/assets/svg/rightIcon.svg';
import saddle from 'src/assets/svg/saddle.svg';
import scanFrame from 'src/assets/svg/scanFrame.svg';
import scooter from 'src/assets/svg/scooter.svg';
import scooterblack from 'src/assets/svg/scooterblack.svg';
import selectedPin from 'src/assets/svg/selectedPin.svg';
import share from 'src/assets/svg/share.svg';
import skip from 'src/assets/svg/skip.svg';
import squerelogo from 'src/assets/svg/squerelogo.svg';
import startbicycle1 from 'src/assets/svg/startbicycle1.svg';
import startbicycle2 from 'src/assets/svg/startbicycle2.svg';
import startbike1 from 'src/assets/svg/startbike1.svg';
import startbike2 from 'src/assets/svg/startbike2.svg';
import startbike3 from 'src/assets/svg/startbike3.svg';
import startbike4 from 'src/assets/svg/startbike4.svg';
import stationpic from 'src/assets/svg/stationpic.svg';
import stationpicblack from 'src/assets/svg/stationpicblack.svg';
import supportIcon from 'src/assets/svg/supportIcon.svg';
import takePhoto from 'src/assets/svg/takePhoto.svg';
import tehranIcon from 'src/assets/svg/tehranIcon.svg';
import tick from 'src/assets/svg/tick.svg';
import tickerStar from 'src/assets/svg/tickerStar.svg';
import timerIcon from 'src/assets/svg/timerIcon.svg';
import tire from 'src/assets/svg/tire.svg';
import tracingCodeIcon from 'src/assets/svg/tracingCodeIcon.svg';
import tripbillfine from 'src/assets/svg/tripbillfine.svg';
import turnOnLocationIcon from 'src/assets/svg/turnOnLocationIcon.svg';
import twitter from 'src/assets/svg/twitter.svg';
import typeOptionIcon from 'src/assets/svg/typeOptionIcon.svg';
import typeOptionIconWhite from 'src/assets/svg/typeOptionIconWhite.svg';
import upIcon from 'src/assets/svg/upIcon.svg';
import uparrow from 'src/assets/svg/uparrow.svg';
import updating from 'src/assets/svg/updating.svg';
import user from 'src/assets/svg/user.svg';
import userIcon from 'src/assets/svg/userIcon.svg';
import userPackages from 'src/assets/svg/userPackages.svg';
import video from 'src/assets/svg/video.svg';
import wallet from 'src/assets/svg/wallet.svg';
import warningIcon from 'src/assets/svg/warningIcon.svg';
import whitecheck from 'src/assets/svg/whitecheck.svg';
import whiteclose from 'src/assets/svg/whiteclose.svg';
import woman from 'src/assets/svg/woman.svg';
import yellowIcon from 'src/assets/svg/yellowIcon.svg';
import yellowwarning from 'src/assets/svg/yellowwarning.svg';
import errorCircle from 'src/assets/svg/errorCircle.svg';
import openCamera from 'src/assets/svg/openCamera.svg';
import bicycleVector from 'src/assets/svg/bicycleVector.svg';
import motorVector from 'src/assets/svg/motorVector.svg';
import motorVectorMado from 'src/assets/svg/motorVectorMado.svg';
import motorVectorTusan from 'src/assets/svg/motorVectorTusan.svg';
import batteryPercent from 'src/assets/svg/batteryPercent.svg';
import altArrowDown from 'src/assets/svg/altArrowDown.svg';
import hourglassLineGray from 'src/assets/svg/hourglassLineGray.svg';
import hourglassLineRed from 'src/assets/svg/hourglassLineRed.svg';
import flashlightOn from 'src/assets/svg/flashlightOn.svg';
import closeCircleRed from 'src/assets/svg/closeCircleRed.svg';
import volume from 'src/assets/svg/volume.svg';
import doubleAltArrowRight from 'src/assets/svg/doubleAltArrowRight.svg';
import altArrowUp from 'src/assets/svg/altArrowUp.svg';
import stopWatchGray from 'src/assets/svg/stopWatchGray.svg';
import stopWatchRed from 'src/assets/svg/stopWatchRed.svg';
import redDiscount from 'src/assets/svg/redDiscount.svg';
import noGift from 'src/assets/svg/noGift.svg';
import noPackage from 'src/assets/svg/noPackage.svg';
import leftChevron from 'src/assets/svg/leftChevron.svg';
import simpleBike from 'src/assets/svg/simpleBike.svg';
import simpleMotor from 'src/assets/svg/simpleMotor.svg';
import lockUnlocked from 'src/assets/svg/lockUnlocked.svg';
import boxMinimalistic from 'src/assets/svg/boxMinimalistic.svg';
import pauseCircleRed from 'src/assets/svg/pauseCircleRed.svg';
import clockCircle from 'src/assets/svg/clockCircle.svg';
import pauseCircleFill from 'src/assets/svg/pauseCircleFill.svg';
import pauseCircleGray from 'src/assets/svg/pauseCircleGray.svg';
import key from 'src/assets/svg/key.svg';
import batteryHorizontal from 'src/assets/svg/batteryHorizontal.svg';
import circleDiscount from 'src/assets/svg/circleDiscount.svg';
import location from 'src/assets/svg/location.svg';
import parking from 'src/assets/svg/parking.svg';
import cube from 'src/assets/svg/cube.svg';
import redPrescription from 'src/assets/svg/redPrescription.svg';
import call from 'src/assets/svg/call.svg';
import headPhone from 'src/assets/svg/headPhone.svg';
import support from 'src/assets/svg/support.svg';
import zeeroSquareLogo from 'src/assets/svg/zeeroSquareLogo.svg';
import outLineCheckCircle from 'src/assets/svg/outLineCheckCircle.svg';
import checkCircleGreen from 'src/assets/svg/checkCircleGreen.svg';
import batteryRed from 'src/assets/svg/batteryRed.svg';
import batteryPurple from 'src/assets/svg/batteryPurple.svg';
import batteryGreen from 'src/assets/svg/batteryGreen.svg';
import fieldError from 'src/assets/svg/fieldError.svg';
import refresh from 'src/assets/svg/refresh.svg';
import terms from 'src/assets/svg/terms.svg';
import banknote from 'src/assets/svg/banknote.svg';
import banknoteGray from 'src/assets/svg/banknoteGray.svg';
import banknoteGreen from 'src/assets/svg/banknoteGreen.svg';
import checkSquareGreen from 'src/assets/svg/checkSquareGreen.svg';
import hourglassLine from 'src/assets/svg/hourglassLine.svg';
import shieldUser from 'src/assets/svg/shieldUser.svg';
import shieldUserGreen from 'src/assets/svg/shieldUserGreen.svg';
import squareArrowLeft from 'src/assets/svg/squareArrowLeft.svg';
import userId from 'src/assets/svg/userId.svg';
import userIdGray from 'src/assets/svg/userIdGray.svg';
import userIdGreen from 'src/assets/svg/userIdGreen.svg';
import userIdFill from 'src/assets/svg/userIdFill.svg';
import calendarAdd from 'src/assets/svg/calendarAdd.svg';
import stepSuccess from 'src/assets/svg/stepSuccess.svg';
import paymentError from 'src/assets/svg/paymentError.svg';
import closeSquare from 'src/assets/svg/closeSquare.svg';
import roundAltArrowLeft from 'src/assets/svg/roundAltArrowLeft.svg';
import pending from 'src/assets/svg/pending.svg';
import videoToast from 'src/assets/svg/videoToast.svg';
import highBattery from 'src/assets/svg/highBattery.svg';
import mediumBattery from 'src/assets/svg/mediumBattery.svg';
import fullBattery from 'src/assets/svg/fullBattery.svg';
import lowBattery from 'src/assets/svg/lowBattery.svg';
import endTripError from 'src/assets/svg/endTripError.svg';
import dangerTriangle from 'src/assets/svg/dangerTriangle.svg';
import redWarning from 'src/assets/svg/redWarning.svg';
import chevronSquare from 'src/assets/svg/chevronSquare.svg';
import userCircle from 'src/assets/svg/userCircle.svg';
import routing from 'src/assets/svg/routing.svg';
import tickerStarFill from 'src/assets/svg/tickerStarFill.svg';
import headphonesRound from 'src/assets/svg/headphonesRound.svg';
import cardTransfer from 'src/assets/svg/cardTransfer.svg';
import userPlus from 'src/assets/svg/userPlus.svg';
import bell from 'src/assets/svg/bell.svg';
import banknoteRed from 'src/assets/svg/banknoteRed.svg';
import altArrowLeftRed from 'src/assets/svg/altArrowLeftRed.svg';
import checkCircleGreenUnfilled from 'src/assets/svg/checkCircleGreenUnfilled.svg';
import tickerStarRed from 'src/assets/svg/tickerStarRed.svg';
import walletMoneyRed from 'src/assets/svg/walletMoneyRed.svg';
import addCircleWhite from 'src/assets/svg/addCircleWhite.svg';
import creditCard from 'src/assets/svg/creditCard.svg';
import paymentFailed from 'src/assets/svg/paymentFailed.svg';
import shieldUserRed from 'src/assets/svg/shieldUserRed.svg';
import inputLock from 'src/assets/svg/inputLock.svg';
import videoFramePlay from 'src/assets/svg/videoFramePlay.svg';
import shareWithFreinds from 'src/assets/svg/shareWithFreinds.svg';
import copy from 'src/assets/svg/copy.svg';
import shareIcon from 'src/assets/svg/shareIcon.svg';
import emptyStreetPana from 'src/assets/svg/emptyStreetPana.svg';
import natureIcon from 'src/assets/svg/natureIcon.svg';
import patrolIcon from 'src/assets/svg/patrolIcon.svg';
import tripHistoryMotor from 'src/assets/svg/tripHistoryMotor.svg';
import tripHistoryBicycle from 'src/assets/svg/tripHistoryBicycle.svg';
import phoneRounded from 'src/assets/svg/phoneRounded.svg';
import linkedinCircle from 'src/assets/svg/linkedinCircle.svg';
import newTwitter from 'src/assets/svg/newTwitter.svg';
import instagramIcon from 'src/assets/svg/instagramIcon.svg';
import mapPointWave from 'src/assets/svg/mapPointWave.svg';
import buildings from 'src/assets/svg/buildings.svg';
import incomingCall from 'src/assets/svg/incomingCall.svg';
import cardRecive from 'src/assets/svg/cardRecive.svg';
import chatDots from 'src/assets/svg/chatDots.svg';
import cardReciveBorder from 'src/assets/svg/cardReciveBorder.svg';
import notificationSample from 'src/assets/svg/notificationSample.svg';
import arrowRight from 'src/assets/svg/arrowRight.svg';
import emptyNotification from 'src/assets/svg/emptyNotification.svg';
import packageHourglass from 'src/assets/svg/packageHourglass.svg';
import playCircle from 'src/assets/svg/playCircle.svg';
import orangeWallet from 'src/assets/svg/orangeWallet.svg';
import circlePlus from 'src/assets/svg/circlePlus.svg';
import grayInfo from 'src/assets/svg/grayInfo.svg';
import redDownArrow from 'src/assets/svg/redDownArrow.svg';
import greenUpArrow from 'src/assets/svg/greenUpArrow.svg';
import circleQuestion from 'src/assets/svg/circleQuestion.svg';
import grayWarning from 'src/assets/svg/grayWarning.svg';
import hourPending from 'src/assets/svg/hourPending.svg';
import securityTerms from 'src/assets/svg/securityTerms.svg';
import darkGrayInfo from 'src/assets/svg/darkGrayInfo.svg';
import blackShare from 'src/assets/svg/blackShare.svg';
import pinParking from 'src/assets/svg/pinParking.svg';
import selectedParking from 'src/assets/svg/selectedParking.svg';
import resMotor from 'src/assets/svg/resMotor.svg';
import resBike from 'src/assets/svg/resBike.svg';
import resDrivingMotor from 'src/assets/svg/resDrivingMotor.svg';
import resDrivingBike from 'src/assets/svg/resDrivingBike.svg';
import selectedFullBike from 'src/assets/svg/selectedFullBike.svg';
import selectedFullMotor from 'src/assets/svg/selectedFullMotor.svg';
import selectedMiddownBike from 'src/assets/svg/selectedMiddownBike.svg';
import selectedMiddownMotor from 'src/assets/svg/selectedMiddownMotor.svg';
import selectedMidupBike from 'src/assets/svg/selectedMidupBike.svg';
import selectedMidupMotor from 'src/assets/svg/selectedMidupMotor.svg';
import selectedDisFullBike from 'src/assets/svg/selectedDisFullBike.svg';
import selectedDisFullMotor from 'src/assets/svg/selectedDisFullMotor.svg';
import selectedDisMiddownBike from 'src/assets/svg/selectedDisMiddownBike.svg';
import selectedDisMiddownMotor from 'src/assets/svg/selectedDisMiddownMotor.svg';
import selectedDisMidupBike from 'src/assets/svg/selectedDisMidupBike.svg';
import selectedDisMidupMotor from 'src/assets/svg/selectedDisMidupMotor.svg';
import orangeWarning from 'src/assets/svg/orangeWarning.svg';
import background from 'src/assets/svg/background.svg';
import chevronCircleRight from 'src/assets/svg/chevronCircleRight.svg';
import chevronCircleLeft from 'src/assets/svg/chevronCircleLeft.svg';
import orangeExclamation from 'src/assets/svg/orangeExclamation.svg';
import arrowRotation from 'src/assets/svg/arrowRotation.svg';
import simpleCamera from 'src/assets/svg/simpleCamera.svg';
import simplePlus from 'src/assets/svg/simplePlus.svg';
import redExclamation from 'src/assets/svg/redExclamation.svg';
import greenTick from 'src/assets/svg/greenTick.svg';
import zeeroVehicle from 'src/assets/svg/zeeroVehicle.svg';
import zeeroVehicleUser from 'src/assets/svg/zeeroVehicleUser.svg';
import zeeroVehicleReserve from 'src/assets/svg/zeeroVehicleReserve.svg';
import security from 'src/assets/svg/security.svg';
import brownBike from 'src/assets/svg/brownBike.svg';
import blueExclamation from 'src/assets/svg/blueExclamation.svg';
import blankMotor from 'src/assets/svg/blankMotor.svg';
import grayAddCircle from 'src/assets/svg/grayAddCircle.svg';
import AzadiTower from 'src/assets/svg/AzadiTower.svg';
import BicycleLearn from 'src/assets/svg/BicycleLearn.svg';
import Camera from 'src/assets/svg/Camera.svg';
import Lock from 'src/assets/svg/Lock.svg';
import MotorLearn from 'src/assets/svg/MotorLearn.svg';
import Smartphone from 'src/assets/svg/Smartphone.svg';
import MotorZin from 'src/assets/svg/MotorZin.svg';
import MotornoZin from 'src/assets/svg/MotornoZin.svg';
import Correct from 'src/assets/svg/Correct.svg';
import Incorrect from 'src/assets/svg/Incorrect.svg';
import Motorbyzin1 from 'src/assets/svg/Motorbyzin1.svg';
import Motorbyzin2 from 'src/assets/svg/Motorbyzin2.svg';
import jack from 'src/assets/svg/jack.svg';
import shop from 'src/assets/svg/shop.svg';
import belllearn from 'src/assets/svg/belllearn.svg';
import brake from 'src/assets/svg/brake.svg';
import lightlearn from 'src/assets/svg/lightlearn.svg';
import controller from 'src/assets/svg/controller.svg';
import wheels from 'src/assets/svg/wheels.svg';
import ShieldWarning from 'src/assets/svg/ShieldWarning.svg';
import motornozinrules from 'src/assets/svg/motornozinrules.svg';
import AppLearn from 'src/assets/svg/AppLearn.svg';
import bicycleparts from 'src/assets/svg/bicycleparts.svg';
import bicyclerules from 'src/assets/svg/bicyclerules.svg';
import Closebottom from 'src/assets/svg/Closebottom.svg';
import Delivery from 'src/assets/svg/Delivery.svg';
import PlayCircle1 from 'src/assets/svg/PlayCircle1.svg';
import vehiclepedal from 'src/assets/svg/vehiclepedal.svg';
import motorzinrules from 'src/assets/svg/motorzinrules.svg';
import farBikeGray from 'src/assets/svg/farBikeGray.svg';
import farMotorGray from 'src/assets/svg/farMotorGray.svg';
import redaltArrowDown from 'src/assets/svg/redaltArrowDown.svg';
export const svgs = {
  farMotorGray,
  farBikeGray,
  plus,
  add,
  bbrake,
  bpedal,
  updating,
  squerelogo,
  frontCamera,
  flash,
  scanFrame,
  qrCodeSample,
  closeCircle,
  arrowLeft,
  goBack,
  arrowLeftBlack,
  cameraAdd,
  galleryCheck,
  bolt,
  refreshBlack,
  checkCircle,
  batteryCharge,
  user,
  blueSetting,
  redAllDevices,
  redBicycle,
  redMotor,
  redParking,
  circleBicycle,
  circleParking,
  circleMotor,
  edit,
  bsaddle,
  tire,
  light,
  mirror,
  body,
  display,
  saddle,
  lockwarning,
  redwarninng,
  backIconWhite,
  penaltycart,
  confrimcharge,
  stationpic,
  stationpicblack,
  return_deposit,
  scooter,
  scooterblack,
  motor_bicycle_scooter,
  motor_bicycle_scooter_black,
  skip,
  logo_icon,
  login,
  whiteclose,
  checkout,
  selectedPin,
  logo,
  increase_by_gateway,
  parkingPin,
  startbike1,
  startbike2,
  startbike3,
  startbike4,
  startbicycle1,
  startbicycle2,
  takePhoto,
  confrimbycicle,
  invt,
  uparrow,
  downarrow,
  icFinanceIcon,
  automate_checkout,
  prize,
  penalty_on_deposit,
  empty,
  buy_product,
  increase_deposit_by_gateway,
  increase_wallet_by_gateway,
  penalty,
  nearst,
  btire,
  blight,
  bbody,
  redIcon,
  redIcondamage,
  cameraIcon,
  leftIcon,
  radiobutton,
  mailIcon,
  supportIcon,
  redleftIcon,
  userIcon,
  historytripsIcon,
  icCodeIcon,
  financeIcon,
  backIcon,
  tracingCodeIcon,
  twitter,
  linkedin,
  instagram,
  address,
  motorsymbol,
  bikesymbol,
  whitecheck,
  icWalletIcon,
  cancelIcon,
  resumeIcon,
  userPackages,
  freeRides,
  tripbillfine,
  dots,
  noidcart,
  khoshamadid1,
  khoshamadid2,
  khoshamadid3,
  share,
  plusIcon,
  checkbox,
  pictureIcon,
  motorbackground,
  motorpicture,
  typeOptionIcon,
  typeOptionIconWhite,
  locationIcon,
  mapOptionIcon,
  bike,
  bikeMotor,
  bikeblack,
  bikeMotorblack,
  bicycleblack,
  bicycle,
  bicyclepicture,
  reservestreetIcon,
  pelakImage,
  battery,
  rightIcon,
  tick,
  warningIcon,
  timerIcon,
  hats,
  endTripIcon,
  endTripIconbycicle,
  cameraAddIcon,
  pauseTripIcon,
  gray,
  yellowIcon,
  yellowwarning,
  closeIcon,
  plusIcon,
  checkbox,
  pictureIcon,
  motorbackground,
  motorpicture,
  typeOptionIcon,
  typeOptionIconWhite,
  locationIcon,
  mapOptionIcon,
  bike,
  bikeMotor,
  bikeblack,
  bikeMotorblack,
  pelakImage,
  counter1,
  counter2,
  turnOnLocationIcon,
  tehranIcon,
  info4,
  circleStep1,
  circleStep2,
  circleStep3,
  info3,
  pen,
  man,
  woman,
  check,
  confrimmotor,
  options,
  noconnection,
  newversion,
  downIcon,
  upIcon,
  photorule,
  video,
  tickerStar,
  wallet,
  altArrowLeft,
  addCircle,
  dangerCircle,
  penSquare,
  closeCircleFill,
  closeSimple,
  openCamera,
  errorCircle,
  bicycleVector,
  motorVector,
  motorVectorMado,
  batteryPercent,
  altArrowDown,
  hourglassLineGray,
  hourglassLineRed,
  flashlightOn,
  closeCircleRed,
  volume,
  doubleAltArrowRight,
  altArrowUp,
  stopWatchGray,
  stopWatchRed,
  redDiscount,
  noPackage,
  noGift,
  leftChevron,
  simpleBike,
  simpleMotor,
  lockUnlocked,
  boxMinimalistic,
  pauseCircleRed,
  clockCircle,
  pauseCircleFill,
  pauseCircleGray,
  key,
  batteryHorizontal,
  circleDiscount,
  location,
  parking,
  cube,
  redPrescription,
  headPhone,
  call,
  support,
  zeeroSquareLogo,
  outLineCheckCircle,
  checkCircleGreen,
  batteryRed,
  batteryPurple,
  batteryGreen,
  fieldError,
  refresh,
  terms,
  banknote,
  banknoteGray,
  banknoteGreen,
  checkSquareGreen,
  hourglassLine,
  shieldUser,
  shieldUserGreen,
  squareArrowLeft,
  userId,
  userIdGray,
  userIdGreen,
  userIdFill,
  calendarAdd,
  stepSuccess,
  paymentError,
  closeSquare,
  roundAltArrowLeft,
  pending,
  videoToast,
  highBattery,
  mediumBattery,
  fullBattery,
  lowBattery,
  endTripError,
  dangerTriangle,
  redWarning,
  chevronSquare,
  userCircle,
  routing,
  tickerStarFill,
  headphonesRound,
  cardTransfer,
  userPlus,
  bell,
  banknoteRed,
  altArrowLeftRed,
  checkCircleGreenUnfilled,
  tickerStarRed,
  walletMoneyRed,
  addCircleWhite,
  creditCard,
  paymentFailed,
  shieldUserRed,
  inputLock,
  videoFramePlay,
  shareWithFreinds,
  copy,
  shareIcon,
  emptyStreetPana,
  natureIcon,
  patrolIcon,
  tripHistoryMotor,
  tripHistoryBicycle,
  phoneRounded,
  linkedinCircle,
  newTwitter,
  instagramIcon,
  mapPointWave,
  buildings,
  incomingCall,
  cardRecive,
  chatDots,
  cardReciveBorder,
  notificationSample,
  arrowRight,
  emptyNotification,
  packageHourglass,
  playCircle,
  orangeWallet,
  circlePlus,
  grayInfo,
  redDownArrow,
  greenUpArrow,
  circleQuestion,
  grayWarning,
  hourPending,
  securityTerms,
  darkGrayInfo,
  blackShare,
  pinParking,
  selectedParking,
  resMotor,
  resBike,
  resDrivingMotor,
  resDrivingBike,
  selectedFullBike,
  selectedFullMotor,
  selectedMiddownBike,
  selectedMiddownMotor,
  selectedMidupBike,
  selectedMidupMotor,
  orangeWarning,
  background,
  chevronCircleLeft,
  chevronCircleRight,
  orangeExclamation,
  arrowRotation,
  simpleCamera,
  simplePlus,
  redExclamation,
  greenTick,
  zeeroVehicle,
  zeeroVehicleUser,
  zeeroVehicleReserve,
  security,
  selectedDisFullMotor,
  selectedDisMiddownBike,
  selectedDisMiddownMotor,
  selectedDisMidupBike,
  selectedDisMidupMotor,
  selectedDisFullBike,
  brownBike,
  blueExclamation,
  blankMotor,
  grayAddCircle,
  motorVectorTusan,
  BicycleLearn,
  Camera,
  Lock,
  MotorLearn,
  Smartphone,
  MotorZin,
  MotornoZin,
  Incorrect,
  Correct,
  Motorbyzin2,
  Motorbyzin1,
  jack,
  shop,
  belllearn,
  brake,
  lightlearn,
  controller,
  wheels,
  ShieldWarning,
  motornozinrules,
  AppLearn,
  bicycleparts,
  bicyclerules,
  Closebottom,
  Delivery,
  PlayCircle1,
  vehiclepedal,
  motorzinrules,
  AzadiTower,
  redaltArrowDown,
};
